// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"541":"da458701","627":"425a1fef"}[chunkId] || chunkId) + "." + {"541":"8c66a72c1f7d2386","627":"8c09d8f6f30e0725","925":"ef068dd0090dbed7","4893":"e2c3afdc870bfb0f","8791":"bdb4e0db39154e45"}[chunkId] + ".js";
};